export default {
  Message: {
    NotIncrementVoucherNoData: 'Tất cả tài sản đã ghi tăng.',
    IncrementVoucherNoData: 'Tất cả chứng từ ghi tăng đã được hạch toán.',
    IncrementVoucherData: 'Bạn chưa hạch toán hết các chứng từ ghi tăng từ MISA QLTS. Vui lòng hạch toán tại đây.',
    AdjustmentNoData: 'Tất cả chứng từ điều chỉnh (đánh giá lại) đã được hạch toán.',
    AdjustmentData: 'Bạn chưa hạch toán hết các chứng từ Đánh giá lại từ MISA QLTS. Vui lòng hạch toán tại đây.',
    RecordedDecreaseNoData: 'Tất cả chứng từ ghi giảm đã được hạch toán.',
    RecordedDecreaseData: 'Bạn chưa hạch toán hết các chứng từ ghi giảm từ MISA QLTS. Vui lòng hạch toán tại đây.',
    NotPostedNoDataUseQlts: 'Tất cả chứng từ liên quan đến tài sản đã ghi sổ.',
    DepreciationNoData: 'Không còn chứng từ hao mòn TSCĐ năm {0} từ MISA QLTS cần hạch toán.',
    DepreciationData: 'Bạn chưa hạch toán hao mòn năm {0} từ MISA QLTS. Vui lòng hạch toán tại đây.',
    NoDepreciationByYear: 'Bạn chưa tính hao mòn năm {0}.',
    DepreciationByYear: 'TSCĐ năm {0} đã được tính hao mòn.',
    MappingSourceQlts:
      'Vui lòng chọn các nguồn trên danh mục nguồn kinh phí tương ứng với nguồn đã được khai báo trên MISA QLTS để việc lấy dữ liệu hạch toán được chính xác.',
  },
  TabName: {
    NotIncrementVoucher: 'Chưa ghi tăng', // Chưa ghi tăng
    IncrementVoucher: 'Ghi tăng', // Ghi tăng
    Adjustment: 'Điều chỉnh', // Điều chỉnh
    RecordedDecrease: 'Ghi giảm', // Ghi giảm
    NotPosted: 'Chưa ghi sổ', // Chưa ghi sổ
    DepreciationCalculation: 'Tính hao mòn', // Tính hao mòn
  },
  Button: {
    CaculateDepreciation: 'Tính hao mòn',
    ViewDetail: 'Xem chi tiết',
  },
  Title: {
    MappingSourceQlts: 'Thực hiện đối chiếu nguồn kinh phí',
  },
};
